import * as React from 'react'
import { FormikProps } from 'formik'
import { IVehicleCreateOptions } from '../../../types'
import { IVehicleObj } from '../../../types/vehicle'
import { IModel } from '../../../types/vehicle'
import EditBottom from '../../vehicles/edit-vehicle/EditBottom'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import { Input, Select, Switch } from '@mobiscroll/react-latest'
import FormLabel from 'src/components/ui/form/FormLabel'

export interface IEditVehicleInfoValues {
  id?: string
  typeId: string
  colorId: string
  fleetId: string
  licensePlate: string
  makeId: string
  modelId: string
  year: string
  isDedicated: boolean
  defaultAddress: string
  city: string
  state: string
  street: string
  zip: string
  country: string
}

interface IEditVehicleProps extends FormikProps<IEditVehicleInfoValues> {
  vehicleCreateOptions: IVehicleCreateOptions
  isLoading: boolean
  currentVehicle: IVehicleObj
}

interface IEditVehicleState {
  models: IModel[]
  selectedMakeId: string
  isSaved: boolean
  isSaving: boolean
}

class EditVehicleInfo extends React.Component<IEditVehicleProps, IEditVehicleState> {
  public state = {
    models: [],
    selectedMakeId: '',
    isSaved: false,
    isSaving: false
  }

  public componentDidUpdate(prevProps: IEditVehicleProps, prevState: IEditVehicleState) {
    if (this.props.values.makeId !== this.state.selectedMakeId && this.props.vehicleCreateOptions) {
      const selectedMake = this.props.vehicleCreateOptions.makes.find(it => it.id === this.props.values.makeId)
      if (selectedMake) {
        this.setState({
          selectedMakeId: selectedMake.id,
          models: this.convertToOptions(selectedMake.models)
        })
      }
    }
  }

  public render() {
    const { isSaved, isSaving } = this.state
    const { values, setFieldValue } = this.props
    const setIsDedicated = () => {
      setFieldValue('isDedicated', !values.isDedicated)
    }
    if (!this.props.vehicleCreateOptions) {
      return null
    }

    const addressOptions = [
      {
        value: 'operator_home_address',
        text: 'Operator Home Address'
      },
      {
        value: 'vehicles_depot_address',
        text: 'Vehicle Depot Address'
      }
    ]
    const { colors, makes, carTypes } = this.props.vehicleCreateOptions
    const selectedType = carTypes.find(t => t.id === this.props.values.typeId)
    const selectedTypeOption = selectedType ? selectedType.name : ''
    const selectedMake = makes.find(m => m.id === this.props.values.makeId)
    const selectedMakeOption = selectedMake ? selectedMake.name : ''
    const selectedColor = colors.find(c => c.id === this.props.values.colorId)
    const selectedColorOption = selectedColor ? selectedColor.name : ''
    const selectedModel = (this.state.models as IModel[]).find(m => m.id === this.props.values.modelId)
    const selectedModelOption = selectedModel ? selectedModel.name : ''
    const selectedDefaultAddress = addressOptions.find(a => a.value === this.props.values.defaultAddress)
    const selectedDefaultAddressOption = selectedDefaultAddress ? selectedDefaultAddress.text : ''
    return (
      <div>
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section main-section'>
            <div className='col-12'>
              <div className='col-12 flex'>
                <div className='col-6 mr1'>
                  <Input
                    label={'License Plate*'}
                    name={'licensePlate'}
                    error={this.props.touched.licensePlate && this.props.errors.licensePlate}
                    touched={this.props.touched.licensePlate}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('licensePlate', true)
                    }}
                    value={this.props.values.licensePlate}
                    className='mobiscroll-input form'
                    placeholder='License Plate'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
                <div className='col-6'>
                  <Input
                    label={'Fleet ID'}
                    name={'fleetId'}
                    error={this.props.touched.fleetId && this.props.errors.fleetId}
                    touched={this.props.touched.fleetId}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('fleetId', true)
                    }}
                    value={this.props.values.fleetId}
                    className='mobiscroll-input form'
                    placeholder='Fleet ID'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='col-12 flex pt2'>
                <div className='col-6 mr1'>
                  <Select
                    name='makeId'
                    data={this.convertToOptions(makes)}
                    disabled={this.props.isLoading}
                    value={selectedMakeOption}
                    onClose={this.handleSelect('makeId')}
                    placeholder='Select Vehicle Make'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Make*`}
                    labelStyle='floating'
                    error={this.props.touched.makeId && this.props.errors.makeId}
                    touched={this.props.touched.makeId}
                  />
                </div>
                <div className='col-6'>
                  <Select
                    name='modelId'
                    data={this.convertToOptions(this.state.models)}
                    disabled={this.props.isLoading}
                    value={selectedModelOption}
                    onClose={this.handleSelect('modelId')}
                    placeholder='Select Vehicle Model'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Model*`}
                    labelStyle='floating'
                    error={this.props.touched.modelId && this.props.errors.modelId}
                    touched={this.props.touched.modelId}
                  />
                </div>
              </div>
              <div className='col-12 flex pt2'>
                <div className='col-6 mr1'>
                  <Select
                    name='typeId'
                    data={this.convertToOptions(carTypes)}
                    disabled={this.props.isLoading}
                    value={selectedTypeOption}
                    onClose={this.handleSelect('typeId')}
                    placeholder='Select Car Type'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Car Type*`}
                    labelStyle='floating'
                    error={this.props.touched.typeId && this.props.errors.typeId}
                    touched={this.props.touched.typeId}
                  />
                </div>
                <div className='col-6'>
                  <Input
                    type='number'
                    min={1900}
                    max={new Date().getFullYear()}
                    label={'Year*'}
                    name={'year'}
                    error={this.props.touched.year && this.props.errors.year}
                    touched={this.props.touched.year}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('year', true)
                    }}
                    value={this.props.values.year}
                    className='mobiscroll-input form'
                    placeholder='Year'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='col-12 flex pt2'>
                <div className='col-6 mr1'>
                  <Select
                    name='colorId'
                    data={this.convertToOptions(colors)}
                    disabled={this.props.isLoading}
                    value={selectedColorOption}
                    onClose={this.handleSelect('colorId')}
                    placeholder='Select Color'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Color*`}
                    labelStyle='floating'
                    error={this.props.touched.colorId && this.props.errors.colorId}
                    touched={this.props.touched.colorId}
                  />
                </div>
                <div className='col-6'>
                  <Select
                    name='defaultAddress'
                    data={addressOptions}
                    disabled={this.props.isLoading}
                    value={selectedDefaultAddressOption}
                    onClose={this.handleSelect('defaultAddress')}
                    placeholder='Select Color'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Default Address*`}
                    labelStyle='floating'
                    error={this.props.touched.defaultAddress && this.props.errors.defaultAddress}
                    touched={this.props.touched.defaultAddress}
                  />
                </div>
              </div>
              <div className='col-6'>
                <div className='mt1 flex flex-row items-center'>
                  <span className='ml1 mr1'>
                    <FormLabel>Dedicated to Product*</FormLabel>
                  </span>
                  <Switch checked={values.isDedicated} onChange={setIsDedicated} position='start' />
                </div>
              </div>

              <div className='flex pt2'>
                <FormLabel>Vehicle Depot Address</FormLabel>
              </div>

              <div className='bb-shadow-grey'>&nbsp;</div>

              <div className='col-12 flex pt2'>
                <div className='col-12'>
                  <Input
                    label={'Street'}
                    name={'street'}
                    error={this.props.touched.street && this.props.errors.street}
                    touched={this.props.touched.street}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('street', true)
                    }}
                    value={this.props.values.street}
                    className='mobiscroll-input form'
                    placeholder='Street'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='col-12 flex pt2'>
                <div className='col-6 mr1'>
                  <Input
                    label={'City'}
                    name={'city'}
                    error={this.props.touched.city && this.props.errors.city}
                    touched={this.props.touched.city}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('city', true)
                    }}
                    value={this.props.values.city}
                    className='mobiscroll-input form'
                    placeholder='City'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
                <div className='col-6'>
                  <Input
                    label={'State'}
                    name={'state'}
                    error={this.props.touched.state && this.props.errors.state}
                    touched={this.props.touched.state}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('state', true)
                    }}
                    value={this.props.values.state}
                    className='mobiscroll-input form'
                    placeholder='State'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='col-12 flex pt2'>
                <div className='col-6 mr1'>
                  <Input
                    label={'Zip'}
                    name={'zip'}
                    error={this.props.touched.zip && this.props.errors.zip}
                    touched={this.props.touched.zip}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('zip', true)
                    }}
                    value={this.props.values.zip}
                    className='mobiscroll-input form'
                    placeholder='Zip'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
                <div className='col-6'>
                  <Input
                    label={'Country'}
                    name={'country'}
                    error={this.props.touched.country && this.props.errors.country}
                    touched={this.props.touched.country}
                    onChange={(event: React.ChangeEvent) => {
                      this.props.handleChange(event)
                      this.props.setFieldTouched('country', true)
                    }}
                    value={this.props.values.country}
                    className='mobiscroll-input form'
                    placeholder='Country'
                    disabled={this.props.isLoading}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    labelStyle='floating'
                  />
                </div>
              </div>
            </div>
          </div>
        </FloatingForm>

        {isSaved ? (
          <div className='w100 p2 bg-green font-white bold fs-14 center border-box'>
            Vehicle {this.props.currentVehicle.make} {this.props.currentVehicle.model} has been successfully updated
          </div>
        ) : (
          <EditBottom
            isSaving={isSaving}
            cancelPath={this.props.values.id ? `/vehicles/view/${this.props.values.id}/details` : `/vehicles/`}
            onSave={this.props.submitForm}
            disabled={!this.props.isValid}
          />
        )}
      </div>
    )
  }

  private convertToOptions = (data: any) => {
    if (!data || !Object.keys(data).length) {
      return [
        {
          value: '',
          text: 'No Options Available',
          disabled: true
        }
      ]
    }
    return data.map((it: any) => {
      return {
        id: it.id,
        value: it.id,
        text: it.name,
        ...it
      }
    })
  }

  private handleSelect = (field: string) => (data: any) => {
    if (field === 'makeId') {
      this.setState({
        models: this.convertToOptions(data.models),
        selectedMakeId: data.id
      })
    }
    this.props.setFieldValue(field, data.value)
    this.props.setFieldTouched(field, true)
  }
}

export default EditVehicleInfo



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/EditVehicleInfo.tsx